<template>
  <div class="chart-chooser">
    <RadioButton
      class="chart-chooser__item"
      :label="t('sentiment_stat_bar.topics')"
      :model-value="localSelectedChart === 0"
      @click="selectChart(0)"
    />
    <RadioButton

      class="chart-chooser__item"
      :label="t('sentiment_stat_bar.rubric')"
      :model-value="localSelectedChart === 1"
      @click="selectChart(1)"
    />
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";
import { t } from "@/controllerLK/AvalLocalization";

const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  modelValue: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["update:modelValue", "beforeUpdate"]);

const localSelectedChart = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("beforeUpdate", value);
    setTimeout(() => {
      emit("update:modelValue", value);
    }, 0);
  }
});


const selectChart = (index) => {
  localSelectedChart.value = index;
};
</script>

<style lang="scss" scoped>
.chart-chooser {
  display: flex;
  flex-direction: column;
  user-select: none;
  gap: 2px;
  border-bottom: 1px solid #EEF1F4;
  padding-bottom: 4px;

  &__item {
    padding: 5px 12px;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      background: #EEF1F4;
    }
  }
}
</style>
